import React from "react";

// reactstrap components
import {  Modal,
          ModalBody,
          ModalFooter,
          Button,
} from "reactstrap";

// core components

function Organigrama(props) {

  return (
    <>
      <Modal isOpen={props.modal} toggle={props.setModal} className="modal-lg modal-dialog modal-dialog-centered" size="lg">
        <div style={{backgroundColor: "White" ,borderRadius: "15px"}}>
            <div className="modal-header">
                <h3> </h3>
                <button
                aria-label="Close"
                className="close"
                type="button"
                onClick={props.setModal}
                >
                <span aria-hidden={true}><i className="now-ui-icons ui-1_simple-remove"></i></span>
                </button>
            </div>
            <ModalBody>
                <h3 className="title text-center" style={{color:"#2c2c2c"}} id="exampleModalLiveLabel">
                  Organigrama
                </h3>
                <img
                      alt="Organigrama de la notaria, comenzando por el notario y terminando por el area legal y recursos humanos"
                      width="100%"
                      src={require("assets/img/Notaria/organigrama.png")}
                  ></img>
                  <br/>
                  <center>
                  <a  type="button" href={"https://drive.google.com/file/d/1_M2fPSh1JY7SpFPMDYTVaJoaffeQCbp7/view?usp=sharing"} style={{borderBottom: "none"}} target="_black">
                    <img
                    alt="Imagen con referencia hacia un icono para descargar un archivo en PDF"
                    width="80px"
                    src={require("assets/img/Notaria/PDF.png")}
                    ></img>
                    <h6  className="texto">Estructura Orgánica</h6>
                  </a>
                </center>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="default"
                    type="button"
                    onClick={props.setModal}
                    className="text-center"
                >
                    <b style={{fontSize: "17px"}}>Cerrar</b>
                </Button>
            </ModalFooter>
        </div>
    </Modal>
    </>
  );
}

export default Organigrama;
